import Text from '../../Text'

import { QA_NAME_CALENDAR_GRID_DAY_LOAD_CHIP } from './CalendarGridDayLoadChip.constants'

import * as styles from './CalendarGridDayLoadChip.module.css'

function CalendarGridDayLoadChip({ children, elementRef, ...restProps }) {
  return (
    <Text
      {...restProps}
      className={styles.CalendarGridDayLoadChip}
      qaName={QA_NAME_CALENDAR_GRID_DAY_LOAD_CHIP}
      ref={elementRef}
    >
      {children}
    </Text>
  )
}

export default CalendarGridDayLoadChip
